import { render, staticRenderFns } from "./TopProduct.vue?vue&type=template&id=142073ca"
import script from "./TopProduct.vue?vue&type=script&lang=js"
export * from "./TopProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports